import React from 'react';
import Icon from '../Icon/Icon';
import Tooltip from '../Tooltip';
import styles from './ClearFiltersButton.module.css';

interface ClearFiltersButtonProps {
  onClick: () => void;
  className?: string;
}

const ClearFiltersButton: React.FC<ClearFiltersButtonProps> = ({ onClick, className }) => (
  <Tooltip content="Limpar filtros">
    <button
      type="button"
      onClick={onClick}
      className={[styles.btn, className].filter(Boolean).join(' ')}
      aria-label="Limpar filtros"
    >
      <Icon name="filter_alt_off" size={16} />
    </button>
  </Tooltip>
);

export default ClearFiltersButton;
